import { render, staticRenderFns } from "./AssetTable.vue?vue&type=template&id=f63d069a&scoped=true&"
import script from "./AssetTable.vue?vue&type=script&lang=ts&"
export * from "./AssetTable.vue?vue&type=script&lang=ts&"
import style0 from "./AssetTable.vue?vue&type=style&index=0&id=f63d069a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63d069a",
  null
  
)

export default component.exports